module.exports = __webpack_public_path__ + "static/img/tool-green.22d50040.png";